import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class AdminProgressTrackingHelper {
  async getStudentsProgress(params = {}) {
    try {
      const response = await ApiHelper.get(API_ENDPOINTS.ADMIN.STUDENTS_PROGRESS, params);
      return response;
    } catch (error) {
      throw new Error(`Failed to fetch students progress: ${error.message}`);
    }
  }
}

export default new AdminProgressTrackingHelper();
